import CheckMarkIcon from "@assets/icons/checkMarkIcon";
import CollapseArrowIcon from "@assets/icons/collapseArrowIcon";
import { PolicyEnum } from "@config/policyEnum";
import { useHasPolicy } from "@config/useHasPolicy";
import {
  Box,
  Card,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";

interface UserSettingsProps {
  handleSwitchChange: () => void;
  active: boolean;
}
const UserSettings: React.FC<UserSettingsProps> = ({
  handleSwitchChange,
  active,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showSettings, setShowSettings] = useState(true);

  const handleCollapse = () => {
    setShowSettings(!showSettings);
  };
 const showUserstatus = useHasPolicy(PolicyEnum.VIEW_USER_STATUS);
 const editUserstatus = useHasPolicy(PolicyEnum.EDIT_USER_STATUS);

  return (
    <>
    {showUserstatus &&
    <Card className="mt-4 md:mt-2 md:!shadow-none">
      <Box className=" hidden md:flex md:items-center bg-[#F2F2F2]" sx={{ ml: '5px' }}>
        <Typography
          sx={{
            padding: "0.5rem 0.5rem 0.5rem 1rem",
            fontWeight: 500,
            fontSize:"15px"
          }}
        >
          Settings
        </Typography>
      </Box>

      <Box className="flex justify-between items-center border-b-2 md:border-b-0 md:hidden">
        <Box className="flex items-center">
          <Typography
            sx={{
              padding: "0.5rem 0.5rem 0.5rem 1rem",
              backgroundColor: { xs: "#fff", sm: "#F2F2F2" },
              fontWeight: 400,
              fontSize:"16px"
            }}
          >
            Settings
          </Typography>
          <CheckMarkIcon />
        </Box>
        <Typography className="pr-3" onClick={handleCollapse}>
          <CollapseArrowIcon />
        </Typography>
      </Box>

      {(showSettings || !isMobile) && (
        <Box className="p-4">
          {showUserstatus &&
          <Box className="flex items-center gap-4 justify-between md:justify-start">
            <Typography variant="body1" className="user-form-lbl">
              User Status <span style={{ color: "red" }}>*</span>
            </Typography>
            <IconButton
              onClick={handleSwitchChange}
              sx={{
                display: "flex",
                alignItems: "center",
                position: "relative",
                border: active ? "2px solid #2196f3" : "2px solid #ccc",
                borderRadius: "30px",
                width: "124px",
                height: "40px",
                cursor: "pointer",
                userSelect: "none",
                overflow: "hidden",
              }}
              disabled={!editUserstatus}
            >
              {/* Sliding Circle */}
              <Box
                sx={{
                  position: "absolute",
                  left: active ? "5px" : "85px",
                  top: "3px",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: active ? "#2196f3" : "#ccc",
                  transition: "left 0.3s ease, background-color 0.3s ease",
                }}
              />
              {/* Centered Text */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: active ? "flex-end" : "flex-start",
                  alignItems: "center",
                  padding: active ? "0 21px" : "0 15px",
                  height: "100%",
                  zIndex: 1, // make sure text is above the circle
                }}
              >
                <Typography
                  variant="subtitle1"
                  // fontWeight=400
                  color={active ? "#2196f3" : "#999"}
                  sx={{ fontWeight:400,
                    fontSize:"14px"}}
                >
                  {active ? "Active" : "Inactive"}
                </Typography>
              </Box>
            </IconButton>
          </Box>}
        </Box>
      )}
    </Card>}
    </>
  );
};

export default UserSettings;
